import { render } from "./PaymentSucceed.vue?vue&type=template&id=5dd77010&scoped=true"
import script from "./PaymentSucceed.vue?vue&type=script&lang=js"
export * from "./PaymentSucceed.vue?vue&type=script&lang=js"

import "./PaymentSucceed.vue?vue&type=style&index=0&id=5dd77010&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd77010"],['__file',"src/components/onboarding/PaymentSucceed.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5dd77010"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5dd77010', __exports__)) {
    api.reload('5dd77010', __exports__)
  }
  
  module.hot.accept("./PaymentSucceed.vue?vue&type=template&id=5dd77010&scoped=true", () => {
    api.rerender('5dd77010', render)
  })

}


export default __exports__